import SpriteSvg from "./svg";

import "./pop-up.scss";
import { IconX } from "@tabler/icons-react";

type Props = {
  children: React.ReactNode,
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const PopUp = ({
  children,
  setIsOpen
}:Props) => {

  return(
    <div className="pop-up">
      <button type="button" className="close" aria-label="Fermer la pop-up" onClick={() => setIsOpen(false)}>
        <IconX/>
      </button>
      {children}
    </div>
  );
};

export default PopUp;
